// Vuex records module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  list: {
    page: 1,
    records: [],
    total: 0,
  },
  filtering_criteria: {},
};

const getters = {
  list: state => state.list,
  filteringCriteria: state => state.filtering_criteria,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
